import { render, staticRenderFns } from "./CeisaBarangImporUpload.vue?vue&type=template&id=713a244b&scoped=true&"
import script from "./CeisaBarangImporUpload.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporUpload.vue?vue&type=script&lang=js&"
import style0 from "./CeisaBarangImporUpload.vue?vue&type=style&index=0&id=713a244b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a244b",
  null
  
)

export default component.exports